import { messages } from '@/shared/i18n';
import type { AccessibleOrganization, SessionUser } from '@/store';

const tc = messages.common;

/** Human-readable chip label from props + email (staff default; guardian menu still uses this for the person row). */
export function resolveChipDisplayName(userName: string, email: string): string {
  const trimmed = userName.trim();
  if (trimmed) {
    return trimmed;
  }
  if (email) {
    const local = email.split('@')[0]?.trim();
    if (local) {
      return local;
    }
  }
  return tc.profilePlaceholder;
}

/** Current session organisation label (aligned with provider list naming). */
export function currentSessionOrganizationLabel(org: SessionUser['organization']): string {
  const nm = (org.tradingName || org.legalEntityName || '').trim();
  return nm || org.id;
}

/**
 * Organisations for the guardian provider picker: API `accessible_organizations`,
 * or a single synthetic row from the active session org when the list is empty.
 */
export function buildGuardianProviderList(user: SessionUser): readonly AccessibleOrganization[] {
  const fromApi = user.accessibleOrganizations;
  if (fromApi.length > 0) {
    return fromApi;
  }
  const o = user.organization;
  const nm = (o.tradingName || o.legalEntityName || '').trim() || o.id;
  return [{ id: o.id, name: nm }];
}
